import React from "react";
import PropTypes from "prop-types";

const styles = {
	container: {
		padding: "18px 14px"
	},
	title: {
		lineHeight: "16px",
		marginBottom: 16
	},
	grid: (columns) => ({
		display: "grid",
		gridTemplateColumns: `repeat(${columns}, 1fr)`,
		gap: "24px"
	}),
	cell: {},
	label: {
		marginBottom: "4px",
		fontSize: "14px",
		lineHeight: "14px",
		color: "#A6AAAE"
	},
	value: {
		wordWrap: "break-word",
		fontSize: "16px",
		lineHeight: "16px",
		color: "white"
	}
};

const DynamicKVPWidget = ({ title, columns = 2, propertiesConfig, entity }) => {
	const renderCellContent = (config) => {
		const value = config.id.split(".").reduce((obj, key) => obj?.[key], entity);
		switch (config.type) {
			case "image":
				return <img src={value} alt={config.label} style={{ maxWidth: "100%" }} />;
			case "link": {
				const linkText = config.linkTextProp
					? config.linkTextProp.split(".").reduce((obj, key) => obj?.[key], entity)
					: config.linkText;
				return (
					<a href={value} target="_blank" rel="noopener noreferrer" style={{ color: "#4DB5F4" }}>
						{linkText || config.label}
					</a>
				);
			}
			case "list":
				return (
					<ul style={{ padding: 0, margin: 0, listStyleType: "none" }}>
						{Array.isArray(value) &&
							value.map((item, idx) => (
								<li key={idx} style={{ marginBottom: "4px" }}>
									{item}
								</li>
							))}
					</ul>
				);
			default:
				return <span>{value}</span>;
		}
	};

	return (
		<div style={styles.container}>
			<div className="cb-font-b2" style={styles.title}>
				<p>{title}</p>
			</div>
			<div style={styles.grid(columns)}>
				{propertiesConfig.map((config, index) => (
					<div
						key={index}
						style={{
							...styles.cell,
							gridColumn: `span ${config.colspan || 1}`,
							gridRow: `span ${config.rowspan || 1}`
						}}
					>
						<div style={styles.label}>{config.label}</div>
						<div style={styles.value}>{renderCellContent(config)}</div>
					</div>
				))}
			</div>
		</div>
	);
};

DynamicKVPWidget.propTypes = {
	actions: PropTypes.array.isRequired,
	alertTime: PropTypes.string.isRequired,
	alertId: PropTypes.string.isRequired,
	alertAcknowledged: PropTypes.bool.isRequired,
	title: PropTypes.string.isRequired,
	columns: PropTypes.number,
	propertiesConfig: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			type: PropTypes.oneOf(["text", "image", "link", "list"]).isRequired,
			colspan: PropTypes.number,
			rowspan: PropTypes.number,
			linkText: PropTypes.string
		})
	).isRequired,
	entity: PropTypes.object.isRequired
};

export default DynamicKVPWidget;
